import { render, staticRenderFns } from "./BookingInformation.vue?vue&type=template&id=01b19c06&scoped=true"
import script from "./BookingInformation.vue?vue&type=script&lang=js"
export * from "./BookingInformation.vue?vue&type=script&lang=js"
import style0 from "./BookingInformation.vue?vue&type=style&index=0&id=01b19c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b19c06",
  null
  
)

export default component.exports